import type { FaqSection } from "./types";

const hybridCompaniesSection: FaqSection = {
  id: "hybrid-vertical",
  title: "Hybrid & Vertically Integrated Solar Companies",
  faqs: [
    {
      question: "What is a Hybrid or Vertically Integrated solar company?",
      answer: (
        <p>
          Hybrid and vertically integrated companies sell, design, and install solar projects in-house. Enerflo provides
          a single platform to manage the entire process, from lead to PTO (Permission to Operate).
        </p>
      ),
    },
    {
      question: "How does Enerflo benefit vertically integrated companies?",
      answer: (
        <p>
          Enerflo removes duplicate work, ensures clean handoffs between departments, and offers real-time project
          tracking across sales, design, permitting, and installation.
        </p>
      ),
    },
    {
      question: "Can vertically integrated companies use Enerflo for financing?",
      answer: (
        <p>
          Yes. Enerflo’s financing integrations let in-house sales teams present loan, lease, and PPA options within
          proposals and instantly submit applications.
        </p>
      ),
    },
    {
      question: "Does Enerflo work for companies with mixed in-house and outsourced labor?",
      answer: (
        <p>
          Yes. Enerflo supports both in-house and subcontracted labor models, with flexible workflows to match each
          company’s operations.
        </p>
      ),
    },
    {
      question: "How does Enerflo handle post-installation customer service?",
      answer: (
        <p>
          Enerflo’s Customer Portal gives homeowners access to their project details, documents, and post-installation
          support resources.
        </p>
      ),
    },
  ],
};

export default hybridCompaniesSection;
